
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.2","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"none","viewBox":"0 0 24 24","width":"44","height":"46"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 12.58V4.65c-1.41-.01-2.79.36-4 1.07a7.99 7.99 0 00-2.92 2.91 7.995 7.995 0 000 8A8.07 8.07 0 007 19.57a7.98 7.98 0 007.12.45c.97-.41 1.84-1 2.58-1.75L11 12.58zm7.62 5.75A7.975 7.975 0 0021 12.65h-8l5.62 5.68zm.64-11c-.7-1.21-1.7-2.21-2.91-2.91a7.788 7.788 0 00-4-1.07v8h8c.01-1.42-.36-2.82-1.09-4.05v.03z"}})])
          )
        }
      }
    